/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, computed, inject, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatListItem, MatListItemIcon, MatListItemLine, MatListItemMeta, MatListItemTitle } from '@angular/material/list';
import { ButtonLinkComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel } from '@libs/shared/models';
import { ViewportService } from '@libs/shared/services';
import { AppLinkRouterService, LinkDirective } from '@libs/shared/ui';
import { CatalogSearchSuggestionModel, ProductImageModel } from '@libs/shop/models';
import { ProductBundleLabelComponent } from '../../catalog/product-labels/';

@Component({
  selector: 'ui-configurable-bundle-suggestion-card',
  imports: [
    LinkDirective,
    MatListItem,
    MatListItemIcon,
    MatListItemLine,
    MatListItemMeta,
    MatListItemTitle,
    ProductBundleLabelComponent,
    ButtonLinkComponent,
    IconComponent,
  ],
  templateUrl: 'configurable-bundle-suggestion-card.component.html',
  styleUrl: 'configurable-bundle-suggestion-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfigurableBundleSuggestionCardComponent {
  private readonly linkRouter: AppLinkRouterService = inject(AppLinkRouterService);
  private readonly viewportService: ViewportService = inject(ViewportService);

  public suggestion: InputSignal<CatalogSearchSuggestionModel> = input.required();
  public clicked: OutputEmitterRef<void> = output();

  public standardImage: Signal<ProductImageModel | undefined> = computed(() =>
    this.suggestion().images?.find(image => image.imageSetName === 'Standard') ?? this.suggestion().images?.[0],
  );

  public link: Signal<NavItemModel> = computed(() => ({
    url: this.linkRouter.getProductRawHref(this.suggestion()),
  }));

  public isMobile: Signal<boolean> = toSignal(this.viewportService.isMobile(), { initialValue: false });
}
